import React from "react";
import VippstarLogo from "../../assets/vippstar_logo.png";
import { Bar, Logo, BarContent } from "./styles";

/**
 * Cabecera común de la aplicación. Los children se colocan a la derecha del
 * logo (buscador, botones de acción…); sin ellos queda la franja con el logo.
 */
const TopBar = ({ children }) => (
  <Bar>
    <Logo>
      <img src={VippstarLogo} alt="Vippstar" />
    </Logo>
    <BarContent>{children}</BarContent>
  </Bar>
);

export default TopBar;
